import { render, staticRenderFns } from "./PreTrainingFormResources.vue?vue&type=template&id=5c3be014&"
import script from "./PreTrainingFormResources.vue?vue&type=script&lang=js&"
export * from "./PreTrainingFormResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports